import { Icon } from '@material-ui/core'
import React from 'react'

export const renderIconDefault = (name: string) => {
  return <Icon>{name}</Icon>
}
